export const ActionTypes = {
  FETCH_VISION_EQUIPMENTS:
    'services/dashboards/vision/visionDashboard/fetch_vision_equipments',
  SET_VISION_EQUIPMENTS:
    'services/dashboards/vision/visionDashboard/set_vision_equipments',
  SET_LOADER_STATUS:
    'services/dashboards/vision/visionDashboard/set_loader_status',
};

const fetchVisionEquipments = ({ visionParams }) => ({
  visionParams,
  type: ActionTypes.FETCH_VISION_EQUIPMENTS,
});

const setVisionEquipments = ({ visionEquipments }) => ({
  visionEquipments,
  type: ActionTypes.SET_VISION_EQUIPMENTS,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchVisionEquipments,
  setVisionEquipments,
  setLoader,
};
